import { TextFieldModule } from '@angular/cdk/text-field';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { TiimeButtonModule, TiimeFormModule, TiimeIconModule, TiimeInputContainerModule } from 'tiime-material';

import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';
import { DocumentRequestStatusEnum } from '@enums/document-request-status.enum';
import { AccountingPeriod } from '@models/accounting-period';
import { DocumentRequest } from '@models/document-request';
import { BalanceSheetsRoute } from '@modules/core/navigation/balance-sheets-route.enum';
import { CompanyRoute } from '@modules/core/navigation/company-route.enum';
import { NavigationService } from '@modules/core/navigation/navigation.service';
import { DocumentRequestComponent } from '@shared-components/document-requests-panel/components/document-request/document-request.component';

@Component({
  selector: 'app-document-request-detail',
  standalone: true,
  imports: [
    DocumentRequestComponent,
    TiimeFormModule,
    ReactiveFormsModule,
    TextFieldModule,
    TiimeInputContainerModule,
    TiimeIconModule,
    TiimeButtonModule,
    RouterLink
  ],
  templateUrl: './document-request-detail.component.html',
  styleUrl: './document-request-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentRequestDetailComponent {
  readonly documentRequest: InputSignal<DocumentRequest> = input.required<DocumentRequest>();
  readonly accountingPeriod: InputSignal<AccountingPeriod | undefined> = input<AccountingPeriod>();
  readonly openOrCloseDocumentRequest: OutputEmitterRef<DocumentRequest> = output<DocumentRequest>();
  readonly downloadCustomerDocument: OutputEmitterRef<number> = output<number>();
  readonly openCustomerDocumentInNewTab: OutputEmitterRef<number> = output<number>();
  protected readonly DocumentRequestModuleType: typeof DocumentRequestModuleType = DocumentRequestModuleType;
  protected readonly DocumentRequestStatusEnum: typeof DocumentRequestStatusEnum = DocumentRequestStatusEnum;
  protected readonly stockRouterLink: Signal<string[]> = toSignal(
    this.navigationService.getRouteFromCurrentCompany([CompanyRoute.balanceSheets, BalanceSheetsRoute.stocks])
  );
  protected readonly showStockRouterLink: Signal<boolean> = computed(() => {
    const documentRequest: DocumentRequest = this.documentRequest();
    return (
      documentRequest.moduleType === DocumentRequestModuleType.STOCK &&
      documentRequest.comment?.includes(
        'Les stocks transmis par le client ont directement été saisis dans le module de stocks'
      )
    );
  });

  constructor(private readonly navigationService: NavigationService) {}
}
